"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setProductImpressionMeta;

function setProductImpressionMeta(loggerData) {
  var nwasetter = window.NWA.metadata.set; // Do we have a metadata setter on NWA ?

  if (nwasetter) {
    nwasetter('offerClientState', loggerData);
  }
}